import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// 1. Suppress generic cross-origin "Script error." overlay
window.addEventListener("error", (event) => {
  if (
    event.message === "Script error." ||
    event.message?.includes("Script error")
  ) {
    event.stopImmediatePropagation();
    console.warn("Cross-origin script suppressed:", event);
  }
});

// 2. Suppress unhandled promise rejections (e.g., failed API fetches)
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason?.message?.includes("Failed to fetch")) {
    event.preventDefault();
    console.warn("Unhandled network fetch suppressed:", event.reason);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
